import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const CuiSideBarButton = ({
  className,
  showClose,
  onOpen,
  onClose,
  ...rest
}) => {
  const classes = classNames('cuiSideBarButton', className, {
    'cuiSideBarButton--open fa fa-bars': !showClose,
    'cuiSideBarButton--close fa fa-close': showClose,
  });

  const onClick = () => {
    if (showClose) {
      onClose();
    } else {
      onOpen();
    }
  };

  return <button className={classes} onClick={onClick} {...rest} />;
};

CuiSideBarButton.propTypes = {
  className: PropTypes.string,
  showClose: PropTypes.bool,
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

CuiSideBarButton.defaultProps = {
  className: undefined,
  showClose: false,
};



// WEBPACK FOOTER //
// ./ui/components/sideBar/SideBarButton.js